import { api, isBackendAvailable } from './client';
import { AuthService } from '../services/AuthService';

export const accountApi = {
  login: (payload) => api.post('auth/login', payload),
  register: (payload) => api.post('auth/register', payload),
  
  logout: () => {
    if (!isBackendAvailable()) {
      // Mock logout - just clear local session
      AuthService.clearSession();
      return Promise.resolve({ status: 'success' });
    }
    
    // Real logout - clear session and call API
    AuthService.clearSession();
    return api.post('auth/logout', {}).catch((error) => {
      return { status: 'success' }; // Consider it successful since session is cleared
    });
  },
  
  me: async () => {
    if (!isBackendAvailable()) {
      // Mock authentication check when backend is offline
      const token = AuthService.getToken();
      if (token && token.startsWith('mock.')) {
        // Return mock user data from stored session
        const session = AuthService.getSession();
        const userId = session.userId || 'mock-user-id';
        const userName = session.userName || 'admin@demo.com';
        const firstName = session.firstName || 'Admin';
        const lastName = session.lastName || 'User';
        const emailAddress = session.emailAddress || 'admin@demo.com';
        
        return {
          userId,
          userName,
          firstName,
          lastName,
          emailAddress,
        };
      } else {
        throw new Error('401: Unauthorized');
      }
    }
    return api.get('auth/me');
  },
  
  requestPasswordReset:(payload)=>api.post('auth/request-password-reset',payload),
  resetPassword:(payload)=>api.post('auth/reset-password',payload),
  
  // Profile management endpoints
  getProfile: () => {
    if (!isBackendAvailable()) {
      // Mock profile data when backend is offline
      const session = AuthService.getSession();
      return Promise.resolve({
        userId: session?.userId || 'demo-user-123',
        userName: session?.userName || 'admin@demo.com',
        firstName: session?.firstName || 'Admin',
        lastName: session?.lastName || 'User',
        emailAddress: session?.emailAddress || 'admin@demo.com',
        phone: '(555) 123-4567',
        address1: '123 Main Street',
        address2: 'Suite 100',
        city: 'Los Angeles',
        state: 'CA',
        zipCode: '90210',
        joinDate: '2024-01-15T10:30:00Z',
        lastLogin: new Date(Date.now()).toISOString(),
        totalSubmissions: 87,
        activePolicies: 16,
        totalPremium: 250000,
        profileImage: null,
        preferences: {
          notifications: true,
          newsletter: true,
          theme: 'dark'
        }
      });
    }
    return api.get('auth/profile');
  },
  
  updateProfile: (profileData) => {
    if (!isBackendAvailable()) {
      // Mock successful update
      return Promise.resolve({
        success: true,
        message: 'Profile updated successfully',
        data: profileData
      });
    }
    return api.put('auth/profile', profileData);
  },
  
  uploadProfileImage: async (imageFile) => {
    if (!isBackendAvailable()) {
      // Mock successful upload
      return {
        success: true,
        message: 'Profile image uploaded successfully',
        imageUrl: URL.createObjectURL(imageFile)
      };
    }
    
    const formData = new FormData();
    formData.append('profileImage', imageFile);
    return api.post('profile/image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  
  updatePassword: async (passwordData) => {
    if (!isBackendAvailable()) {
      // Mock successful password change
      return {
        success: true,
        message: 'Password updated successfully'
      };
    }
    return api.post('auth/change-password', passwordData);
  },
  
  getProfileStats: async () => {
    if (!isBackendAvailable()) {
      // Mock profile statistics
      return {
        totalSubmissions: 87,
        activePolicies: 16,
        totalPremium: 250000,
        monthlySubmissions: 31,
        todaySubmissions: 4,
        yearlySubmissions: 87,
        recentActivity: [
          { type: 'submission', description: 'New application submitted', date: new Date().toISOString() },
          { type: 'policy', description: 'Policy renewed', date: new Date(Date.now() - 86400000).toISOString() },
          { type: 'login', description: 'Logged in', date: new Date(Date.now() - 172800000).toISOString() }
        ]
      };
    }
    return api.get('profile/stats');
  },
};



